/**
 * Immunities, weaknesses and resistances entered by hand (#22): the list on the Character, edited
 * from the sheet. Entries are cleaned as Foundry's IWR editor cleans them: a whole value of at
 * least 1 (none on an immunity), exceptions and doubled types without the entry's own type or
 * duplicates, an empty note dropped.
 */
import type { ManualIWR } from "./model";

/** A cleaned copy of an entry, or null when it names no type. */
export function cleanManualIWR(entry: ManualIWR): ManualIWR | null {
  const type = entry.type.trim();
  if (!type) return null;
  const list = (values: string[] | undefined): string[] => [...new Set((values ?? []).map((v) => v.trim()).filter((v) => v && v !== type))];
  const out: ManualIWR = { kind: entry.kind, type };
  if (entry.kind !== "immunity") out.value = Math.max(1, Math.trunc(Math.abs(Number(entry.value))) || 1);
  const exceptions = list(entry.exceptions);
  if (exceptions.length > 0) out.exceptions = exceptions;
  if (entry.kind === "resistance") {
    const doubleVs = list(entry.doubleVs);
    if (doubleVs.length > 0) out.doubleVs = doubleVs;
  }
  const note = entry.note?.trim();
  if (note) out.note = note;
  return out;
}

/** The kinds in sheet order. */
export const IWR_KINDS: readonly ManualIWR["kind"][] = ["immunity", "weakness", "resistance"];

/** Foundry's table for a kind (`CONFIG.PF2E.immunityTypes`, ...). */
export const IWR_TABLE_BY_KIND: Readonly<Record<ManualIWR["kind"], string>> = { immunity: "immunityTypes", weakness: "weaknessTypes", resistance: "resistanceTypes" };
